import EditUserFormContainer from './EditUserFormContainer';
import AddUser from './services/AddUser';
import GetUser from './services/GetUser';
import EditUser from './services/EditUser';
import stores from './stores';

const EditUserForm = {
  path: ['/edit-user/','/add-admin'],
  exact: false,
  services: [new AddUser(), new GetUser(), new EditUser()],
  stores: stores,
  component: EditUserFormContainer
};

export default EditUserForm;
